import { render } from "./sales-list-modal.vue?vue&type=template&id=bd4bf746&scoped=true"
import script from "./sales-list-modal.vue?vue&type=script&lang=js"
export * from "./sales-list-modal.vue?vue&type=script&lang=js"

import "./sales-list-modal.vue?vue&type=style&index=0&id=bd4bf746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4bf746"]])

export default __exports__